<template>
  <div>
    <div class="backdrop">
      <div class="background">

      </div>
      <div class="layout" @click="onBackdropClick()">
        <div class="child pdng-1" @click.stop>
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'Modal',
    methods: {
      onBackdropClick() {
        this.$emit('background-click')
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "../../scss/main";

  .backdrop {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    .background {
      width: 100%;
      height: 100%;
      background: $cyan-blue-4;
      opacity: .75;
      position: absolute;
      z-index: -1;
    }

    .layout {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      .child {
        max-width: 500px;
      }
    }
  }

</style>
